import ExportRegister from "pages/LandingPages/Export";

export default function ExportRegisterPage() {
  return <ExportRegister />;
}
